import React__default from 'react';
import { S as StyledSvg, V as Variant } from './StyledSvg-Bc-aUfmk.js';

const NeitherSatisfiedNorDissatisfied = ({
  disabled,
  checked
}) => /*#__PURE__*/React__default.createElement(StyledSvg, {
  $checked: checked,
  $disabled: disabled,
  $variant: Variant.NEITHER_SATISFIED_NOR_DISSATISFIED,
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "15",
  cy: "15",
  r: "15"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 2C7.8203 2 2 7.8203 2 15C2 22.1797 7.8203 28 15 28C22.1797 28 28 22.1797 28 15C28 7.8203 22.1797 2 15 2ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 20C8 19.4477 8.44772 19 9 19L21 19C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21L9 21C8.44772 21 8 20.5523 8 20Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 11C12 12.1046 11.1046 13 10 13C8.89543 13 8 12.1046 8 11C8 9.89543 8.89543 9 10 9C11.1046 9 12 9.89543 12 11Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 13C11.1046 13 12 12.1046 12 11C12 9.89543 11.1046 9 10 9C8.89543 9 8 9.89543 8 11C8 12.1046 8.89543 13 10 13Z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22 11C22 12.1046 21.1046 13 20 13C18.8954 13 18 12.1046 18 11C18 9.89543 18.8954 9 20 9C21.1046 9 22 9.89543 22 11Z"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 13C21.1046 13 22 12.1046 22 11C22 9.89543 21.1046 9 20 9C18.8954 9 18 9.89543 18 11C18 12.1046 18.8954 13 20 13Z"
}));

export { NeitherSatisfiedNorDissatisfied as N };
//# sourceMappingURL=NeitherSatisfiedNorDissatisfied-BaUvU_JW.js.map
